import React from 'react'
import './Section5.css'

const Section5 = () => {
  return (
    <div className="section1-container" id='NEW'>
        <video  src="https://res.cloudinary.com/facemetaclone/video/upload/v1662241375/pexels-julia-m-cameron-6893219_qqkbvy.mp4" type='video/mp4/' className='bg-video' autoPlay loop muted>
        </video>
    </div>
  )
}

export default Section5